import type {RetentionBookmarkParams} from 'common/report/retention/util/types';
import type {Retention, SuccessResponse} from 'common/report/retention/models/types';
import type {ParamsAndResults} from 'common/report/types';
import {InsightsBookmarkParams, InsightsQueryResults} from 'common/report/insights/util/types';

export type RetentionBookmarkParamsAndResults = ParamsAndResults<RetentionBookmarkParams, SuccessResponse>;

export enum RetentionBookmarkType {
  RETENTION = `retention`,
  MULTIMETRIC = `multimetric`,
}

export type MultimetricData = {
  bookmark: InsightsBookmarkParams;
  queryResults: InsightsQueryResults<Retention>;
  type: RetentionBookmarkType.MULTIMETRIC;
};

export type RetentionData = {
  bookmark: RetentionBookmarkParams;
  queryResults: SuccessResponse;
  type: RetentionBookmarkType.RETENTION;
};

export type BookmarkData = MultimetricData | RetentionData;
